import { aboutus2 } from "./en/aboutus2";
import { adminFinance } from "./en/adminFinance";
import { brandStrategy } from "./en/brandStrategy";
import { customerRelations } from "./en/customerRelations";
import { dailyAssistant } from "./en/dailyAssistant";
import { admin } from "./en/admin";
import { affiliate } from "./en/affiliate";
import { aiAssistant } from "./en/aiAssistant";
import { aiAnalytics } from "./en/aiAnalytics";
import { appointments } from "./en/appointments";
import { asszisztensNaptar } from "./en/asszisztensNaptar";
import { auth } from "./en/auth";
import { bookingSystem } from "./en/bookingSystem";
import { burjanfanni } from "./en/burjanfanni";
import { checkout } from "./en/checkout";
import { common } from "./en/common";
import { components } from "./en/components";
import { content } from "./en/content";
import { creator } from "./en/creator";
import { creatorWorld } from "./en/creatorWorld";
import { customers } from "./en/customers";
import { gaming } from "./en/gaming";
import { interactiveData } from "./en/interactiveData";
import { interactiveFeatures } from "./en/interactiveFeatures";
import { landing2 } from "./en/landing2";
import { landing4 } from "./en/landing4";
import { landing5 } from "./en/landing5";
import { landing6 } from "./en/landing6";
import { landingPage } from "./en/landingPage";
import { marketingAutomation } from "./en/marketingAutomation";
import { media } from "./en/media";
import { meetings } from "./en/meetings";
import { onboarding } from "./en/onboarding";
import { orders } from "./en/orders";
import { partners } from "./en/partners";
import { partnersReg } from "./en/partnersReg";
import { personalVideo } from "./en/personalVideo";
import { personas } from "./en/personas";
import { pitchdeck } from "./en/pitchdeck";
import { platformBenefits } from "./en/platformBenefits";
import { pricing2 } from "./en/pricing2";
import { pumpedgabo } from "./en/pumpedgabo";
import { selection } from "./en/selection";
import { services } from "./en/services";
import { smbOnboarding } from "./en/smbOnboarding";
import { smbOnboarding2 } from "./en/smbOnboarding2";
import { szakacsgeri } from "./en/szakacsgeri";
import { tsmtPartner } from "./en/tsmtPartner";
import { contractors } from "./en/contractors";
import { tsmtPitch } from "./en/tsmtPitch";
import { tsmtPitchTherapists } from "./en/tsmtPitchTherapists";
import { tsmtWebinar } from "./en/tsmtWebinar";
import { tsmtKommunikacioPlaybook } from "./en/tsmtKommunikacioPlaybook";
import { useCase } from "./en/use-case";
import { userAdmin } from "./en/userAdmin";
import { userAdmin3 } from "./en/userAdmin3";
import { users } from "./en/users";
import { websiteBuilder } from "./en/websiteBuilder";
import { whiteLabel } from "./en/whiteLabel";
import { aboutLanding4 } from "./en/aboutLanding4";
import { coachWorld } from "./en/coachWorld";
import { rounds } from "./en/rounds";
import { socialStudio } from "./en/socialStudio";

export const en = {
  aboutLanding4,
  coachWorld,
  aboutus2,
  adminFinance,
  brandStrategy,
  customerRelations,
  dailyAssistant,
  admin,
  affiliate,
  aiAssistant,
  aiAnalytics,
  appointments,
  asszisztensNaptar,
  auth,
  bookingSystem,
  burjanfanni,
  checkout,
  common,
  components,
  content,
  creator,
  creatorWorld,
  customers,
  gaming,
  interactiveData,
  interactiveFeatures,
  landing2,
  landing4,
  landing5,
  landing6,
  landingPage,
  marketingAutomation,
  media,
  meetings,
  onboarding,
  orders,
  partners,
  partnersReg,
  personalVideo,
  personas,
  pitchdeck,
  platformBenefits,
  pricing2,
  pumpedgabo,
  rounds,
  selection,
  services,
  smbOnboarding,
  smbOnboarding2,
  socialStudio,
  szakacsgeri,
  tsmtPartner,
  contractors,
  tsmtPitch,
  tsmtPitchTherapists,
  tsmtWebinar,
  tsmtKommunikacioPlaybook,
  useCase,
  userAdmin,
  userAdmin3,
  users,
  websiteBuilder,
  whiteLabel,
};

export default en;
